import Scrollbar from './scrollbar';

export default Scrollbar;
